import moment from 'moment';

import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';

export enum EDateTypes {
  CREATED = 'created_at',
  REFUNDED = 'refunded_at',
  PAID = 'received_at',
  CLICKED = 'clicked_at',
  CREDITED = 'credited_at',
  EXPIRATION = 'expiration_at',
}

export enum ECustomerSearchTypes {
  NAME = 'customer_name',
  EMAIL = 'customer_email',
  DOCUMENT = 'document_number',
}

export const DateTypes = [
  { label: 'Criação', value: EDateTypes.CREATED },
  { label: 'Clique', value: EDateTypes.CLICKED },
  { label: 'Crédito', value: EDateTypes.CREDITED },
  // { label: 'Reembolso', value: EDateTypes.REFUNDED },
  { label: 'Pagamento', value: EDateTypes.PAID },
  { label: 'Vencimento', value: EDateTypes.EXPIRATION },
];

export const CustomerTypes = [
  { label: 'CPF/CNPJ', value: ECustomerSearchTypes.DOCUMENT },
  { label: 'Email', value: ECustomerSearchTypes.EMAIL },
  { label: 'Nome', value: ECustomerSearchTypes.NAME },
];

export const InvoiceStatus = [
  { id: 1, label: 'Aberta', value: 'open' },
  { id: 15, label: 'Aguardando pagamento', value: 'waiting_payment' },
  { id: 6, label: 'Aguardando reembolso', value: 'waiting_refund' },
  { id: 4, label: 'Cancelada', value: 'canceled' },
  { id: 9, label: 'Duplicada', value: 'duplicated' },
  { id: 11, label: 'Em recuperação', value: 'recovering' },
  { id: 10, label: 'Expirada', value: 'expired' },
  { id: 19, label: 'Negociada', value: 'negociated' },
  { id: 3, label: 'Paga', value: 'paid' },
  { id: 7, label: 'Reembolsado', value: 'refunded' },
  { id: 55, label: 'Reembolso parcial', value: 'partial_refund' },
];

export const PaymentTypes = [
  { id: 2, label: 'Boleto', value: 'boleto' },
  { id: 1, label: 'Cartão de crédito', value: 'credit' },
  { id: 3, label: 'Paypal', value: 'paypal' },
  { id: 4, label: 'PIX', value: 'pix' },
  { id: 5, label: 'Saldo Eduzz', value: 'eduzz_balance' },
];

export const ChargeTypes = [
  { id: 2, label: 'Assinatura', value: 'A' },
  { id: 3, label: 'Gratuito', value: 'G' },
  { id: 1, label: 'Pagamento único', value: 'N' },
];

export const GainTypes = [
  { id: 1, value: 'affiliate', label: 'Afiliado' },
  { id: 2, value: 'coaffiliate', label: 'Co-Afiliado' },
  { id: 3, value: 'coproducer', label: 'Co-Produtor' },
  { id: 4, value: 'producer', label: 'Produtor' },
];

export const OriginSales = [
  { id: 1, value: 'affiliate', label: 'Afiliado' },
  { id: 2, value: 'producer', label: 'Produtor' },
];

interface IFilter {
  date_type: EDateTypes;
  date: string[];
  customer_type?: string;
  customer?: string;
  invoice_id?: any | any[];
  payment_status?: string[];
  charge_type?: any[];
  payment_method?: any[];
  product_id?: any[];
  orderby?: string;
  affiliates: IAffiliateOption[];
  affiliate_id?: number[];
  specific_filters?: [];
  contract_id?: any | any[];
  coupon_id?: any | any[];
  type?: any[];
  utms?: any | any[];
  advanced?: boolean;
  courtesy_recovery?: boolean;
  recovery?: boolean;
  infinity_funnel?: boolean;
  order_bump?: boolean;
  refund_type?: any;
  origin_sale?: any;
  fast_sale?: boolean;
  upsell?: boolean;
  one_click_buy?: boolean;
  chargeback?: boolean;
  unlimited_installment?: boolean;
}

const today = moment().format('DD/MM/YYYY');

export const InitialFilter: IFilter = {
  date_type: EDateTypes.CREATED,
  date: [today, today],
  customer_type: ECustomerSearchTypes.EMAIL,
  customer: '',
  invoice_id: [],
  payment_status: [],
  product_id: [],
  payment_method: [],
  charge_type: [],
  specific_filters: [],
  affiliates: [],
  affiliate_id: [],
  contract_id: [],
  coupon_id: [],
  type: [],
  utms: [],
  courtesy_recovery: false,
  recovery: false,
  infinity_funnel: false,
  order_bump: null,
  origin_sale: '',
  advanced: false,
  chargeback: false,
  unlimited_installment: false,
  upsell: false,
  fast_sale: false,
};

export default IFilter;
